import React from "react";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { postCreateContact } from "services/Contact.service";
import "styles/ContactNew.css";

const Contact = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = handleSubmit(async (datos) => {
    try {
      await postCreateContact(datos);
      toast.success("Formulario enviado correctamente");
      reset();
    } catch (error) {
      console.error("ERROR", error);
      toast.error("Ocurrió un error, inténtelo de nuevo");
    }
  });

  const backgroundStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/images/EliteVacances/BannerContacto.jpg)`,
  };

  return (
    <>
      {/* Hero Banner */}
      <section className="contact-hero">
        <div className="contact-hero__background" style={backgroundStyle}>
          <div className="contact-hero__overlay"></div>
        </div>
        <div className="contact-hero__content">
          <h1 className="contact-hero__title">Contáctanos</h1>
        </div>
      </section>

      {/* Oficinas Section */}
      {/* <section className="contact-offices">
        <h2 className="contact-offices__title">Nuestras Oficinas</h2>
        <div className="contact-offices__grid">
          {sedes.map((sede, index) => (
            <div className="contact-offices__item" key={index}>
              <div className="contact-offices__icon">
                <Ubicacion />
              </div>
              <div className="contact-offices__info">
                <h3 className="contact-offices__name">{sede.sede}</h3>
                <p className="contact-offices__address">
                  {sede.ubicacion.toLowerCase()} -{" "}
                  {sede.direccion.toLowerCase()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Form & Channels Section */}
      <section className="contact-form-section">
        <div className="contact-form-section__container">
          {/* Formulario */}
          <form onSubmit={onSubmit} className="contact-form">
            <div className="contact-form__group">
              <label className="contact-form__label" htmlFor="nombres">
                Nombres y apellidos
              </label>
              <input
                id="nombres"
                type="text"
                className={`contact-form__input ${
                  errors.nombre ? "invalid" : ""
                }`}
                {...register("nombre", {
                  required: "El campo Nombre es obligatorio",
                })}
              />
              {errors.nombre && (
                <span className="contact-form__error">
                  {errors.nombre.message}
                </span>
              )}
            </div>

            <div className="contact-form__row">
              <div className="contact-form__group">
                <label className="contact-form__label" htmlFor="pais">
                  País
                </label>
                <input
                  id="pais"
                  type="text"
                  className={`contact-form__input ${
                    errors.pais ? "invalid" : ""
                  }`}
                  {...register("pais", {
                    required: "El campo País es obligatorio",
                  })}
                />
                {errors.pais && (
                  <span className="contact-form__error">
                    {errors.pais.message}
                  </span>
                )}
              </div>

              <div className="contact-form__group">
                <label className="contact-form__label" htmlFor="ciudad">
                  Ciudad
                </label>
                <input
                  id="ciudad"
                  type="text"
                  className={`contact-form__input ${
                    errors.ciudad ? "invalid" : ""
                  }`}
                  {...register("ciudad", {
                    required: "El campo Ciudad es obligatorio",
                  })}
                />
                {errors.ciudad && (
                  <span className="contact-form__error">
                    {errors.ciudad.message}
                  </span>
                )}
              </div>

              <div className="contact-form__group">
                <label className="contact-form__label" htmlFor="telefono">
                  Teléfono
                </label>
                <input
                  id="telefono"
                  type="tel"
                  className={`contact-form__input ${
                    errors.telefono ? "invalid" : ""
                  }`}
                  {...register("telefono", {
                    required: "El campo Teléfono es obligatorio",
                  })}
                />
                {errors.telefono && (
                  <span className="contact-form__error">
                    {errors.telefono.message}
                  </span>
                )}
              </div>
            </div>

            <div className="contact-form__row contact-form__row--2">
              <div className="contact-form__group">
                <label className="contact-form__label" htmlFor="correo">
                  Correo electrónico
                </label>
                <input
                  id="correo"
                  type="email"
                  className={`contact-form__input ${
                    errors.correo ? "invalid" : ""
                  }`}
                  {...register("correo", {
                    required: "El campo Correo es obligatorio",
                  })}
                />
                {errors.correo && (
                  <span className="contact-form__error">
                    {errors.correo.message}
                  </span>
                )}
              </div>

              <div className="contact-form__group">
                <label className="contact-form__label" htmlFor="cedula">
                  Número de identificación
                </label>
                <input
                  id="cedula"
                  type="text"
                  className={`contact-form__input ${
                    errors.cedula ? "invalid" : ""
                  }`}
                  {...register("cedula", {
                    required: "El campo Cédula es obligatorio",
                  })}
                />
                {errors.cedula && (
                  <span className="contact-form__error">
                    {errors.cedula.message}
                  </span>
                )}
              </div>
            </div>

            <div className="contact-form__group">
              <label className="contact-form__label" htmlFor="mensaje">
                Mensaje
              </label>
              <textarea
                id="mensaje"
                className={`contact-form__textarea ${
                  errors.mensaje ? "invalid" : ""
                }`}
                rows={4}
                {...register("mensaje", {
                  required: "El campo Mensaje es obligatorio",
                })}
              />
              {errors.mensaje && (
                <span className="contact-form__error">
                  {errors.mensaje.message}
                </span>
              )}
            </div>

            <div className="contact-form__actions">
              <div className="contact-form__checkbox-container">
                <input
                  type="checkbox"
                  id="acceptTerms"
                  className="contact-form__checkbox"
                  {...register("acceptTerms", {
                    required: "Debes aceptar los términos para continuar",
                  })}
                />
                <label
                  htmlFor="acceptTerms"
                  className="contact-form__checkbox-label"
                >
                  Con el diligenciamiento de mis datos en el presente formulario
                  acepto de forma previa, expresa e informada la Autorización
                  para el tratamiento de datos personales. ver{" "}
                  <a href="/files/TRATAMIENTO_DE_DATOS_PERSONALES.pdf">
                    Tratamiento de datos personales
                  </a>
                </label>
              </div>

              <button
                type="submit"
                className="contact-form__submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Enviar"
                )}
              </button>
            </div>
            {errors.acceptTerms && (
              <span className="contact-form__error">
                {errors.acceptTerms.message}
              </span>
            )}
          </form>

          {/* Sidebar - Canales y Horarios */}
          <aside className="contact-sidebar">
            <div className="contact-channels">
              <h3 className="contact-channels__title">Canales de atención</h3>

              <a href="tel:+5717945996" className="contact-channels__item">
                +57 (1) 7945996
              </a>

              <a
                href="mailto:sac@elitevacances.com"
                className="contact-channels__item"
              >
                sac@elitevacances.com
              </a>

              <a
                href="mailto:reservas@elitevacances.com"
                className="contact-channels__item"
              >
                reservas@elitevacances.com
              </a>
            </div>

            <div className="contact-principal">
              <h4 className="contact-channels__title">Oficina Principal</h4>
              <p className="contact-principal__text">
                Bogotá, Calle 93B # 19-57 oficina 302
              </p>
            </div>

            <div className="contact-schedule">
              <h3 className="contact-schedule__title">Horario de atención</h3>
              <p className="contact-schedule__item">
                Lunes a viernes: 8:00 AM - 7:00 PM
              </p>
              <p className="contact-schedule__item">
                Sábados: 9:00 AM - 3:00 PM
              </p>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
};

export default Contact;
